import { default as i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import de from './de.json';

export const initI18nNext = () => {
    const instance = i18n.createInstance();

    instance
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            resources: {
                en: { translation: en },
                de: { translation: de },
            },
            lng: 'de',
            fallbackLng: 'de',
            interpolation: {
                escapeValue: false,
            },
        });

    return instance;
};
